import React from 'react';
import { motion } from 'framer-motion';
import { MockupBook } from '../ui/MockupBook';
import { BookOpen } from 'lucide-react';
export function ProductIntro() {
  return <section className="py-20 px-4 max-w-6xl mx-auto" data-id="element-189">
      <div className="text-center mb-16" data-id="element-190">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-bold text-oscuro mb-6" data-id="element-191">
          🏆 El Sistema N°1 para Profesores
          <br className="hidden md:block" data-id="element-192" />
          de Yoga Argentinos
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="text-xl md:text-2xl text-gray-600 space-y-2" data-id="element-193">
          <p className="font-bold text-terracota" data-id="element-194">
            YOGA 360 — Colección Completa
          </p>
          <p data-id="element-195">
            12 Tomos + 6 Bonus + 2 Élite —<br data-id="element-196" />
            Todo resuelto, todos los niveles.
          </p>
        </motion.div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 max-w-4xl mx-auto" data-id="element-197">
        {['+280 páginas', '+150 ejercicios detallados', 'Todos los niveles'].map((metric, idx) => <motion.div key={idx} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4 + idx * 0.1
      }} className="bg-white p-6 rounded-xl shadow-sm text-center border border-terracota/10" data-id="element-198">
            <p className="font-bold text-oscuro text-lg" data-id="element-199">{metric}</p>
          </motion.div>)}
      </div>
    </section>;
}